import React from 'react';
import AdminDataTable from './AdminDataTable';
import { 
  faFileLines, 
  faEye, 
  faGlobe
} from '@fortawesome/free-solid-svg-icons';

/**
 * Configuration pour l'administration des modèles IA
 */
const iaModelsConfig = {
  entityName: 'models',
  apiEndpoint: '/api/config/tool/ia-models',
  exportFileName: 'ia-models',
  
  translations: {
    title: 'IA_MODELS_TITLE'
  },
  
  columns: [
    { key: 'id', label: 'ID', labelKey: 'TABLE_ID' },
    { key: 'provider', label: 'Fournisseur', labelKey: 'TABLE_PROVIDER' },
    { key: 'model_key', label: 'Clé', labelKey: 'TABLE_MODEL_KEY' },
    { key: 'model_name', label: 'Nom', labelKey: 'TABLE_MODEL_NAME' },
    { key: 'model_identifier', label: 'Identifiant', labelKey: 'TABLE_MODEL_IDENTIFIER' },
    { 
      key: 'has_text', 
      label: 'Texte', 
      labelKey: 'TABLE_HAS_TEXT',
      labelIcon: faFileLines,
      type: 'booleanTag',
    },
    { 
      key: 'has_vision', 
      label: 'Vision', 
      labelKey: 'TABLE_HAS_VISION',
      labelIcon: faEye,
      type: 'booleanTag',
    },
    { 
      key: 'has_translation', 
      label: 'Traduction', 
      labelKey: 'TABLE_HAS_TRANSLATION',
      labelIcon: faGlobe,
      type: 'booleanTag',
    },
    { 
      key: 'is_active', 
      label: 'Actif', 
      labelKey: 'TABLE_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  formFields: [
    {
      name: 'provider',
      label: 'Fournisseur',
      labelKey: 'IA_MODEL_PROVIDER',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'provider'
    },
    {
      name: 'model_key',
      label: 'Clé du modèle',
      labelKey: 'IA_MODEL_KEY',
      type: 'text',
      required: true,
      placeholder: 'ex: gpt-4, claude-3...'
    },
    {
      name: 'model_name',
      label: 'Nom du modèle',
      labelKey: 'IA_MODEL_NAME',
      type: 'text',
      required: true,
      placeholder: 'Nom complet du modèle'
    },
    {
      name: 'model_identifier',
      label: 'Identifiant API',
      labelKey: 'IA_MODEL_IDENTIFIER',
      type: 'text',
      required: true,
      placeholder: 'Identifiant utilisé par l\'API'
    },
    {
      name: 'ia_router',
      label: 'Routeur IA',
      labelKey: 'IA_MODEL_ROUTER',
      type: 'dynamic-select',
      required: true,
      dynamicSource: 'ia_router'
    },
    {
      name: 'ia_router_url',
      label: 'URL du routeur',
      labelKey: 'IA_MODEL_ROUTER_URL',
      type: 'url',
      placeholder: 'URL optionnelle pour le routeur'
    },
    {
      name: 'has_text',
      label: 'Support texte',
      labelKey: 'IA_MODEL_HAS_TEXT',
      type: 'booleanTag'
    },
    {
      name: 'has_vision',
      label: 'Support vision',
      labelKey: 'IA_MODEL_HAS_VISION',
      type: 'booleanTag'
    },
    {
      name: 'has_translation',
      label: 'Support traduction',
      labelKey: 'IA_MODEL_HAS_TRANSLATION',
      type: 'booleanTag'
    },
    {
      name: 'supported_languages',
      label: 'Langues supportées',
      labelKey: 'IA_MODEL_SUPPORTED_LANGUAGES',
      type: 'text',
      placeholder: 'ex: fr,en,es (séparées par des virgules)'
    },
    {
      name: 'is_active',
      label: 'Actif',
      labelKey: 'IA_MODEL_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  filters: [
    {
      name: 'provider',
      label: 'Fournisseur',
      labelKey: 'FILTER_PROVIDER',
      type: 'dynamic-select',
      dynamicSource: 'provider'
    },
    {
      name: 'model_key',
      label: 'Clé du modèle',
      labelKey: 'FILTER_MODEL_KEY',
      type: 'text',
      placeholder: 'Recherche par clé...'
    },
    {
      name: 'has_text',
      label: 'Support texte',
      labelKey: 'FILTER_HAS_TEXT',
      type: 'booleanTag'
    },
    {
      name: 'has_vision',
      label: 'Support vision',
      labelKey: 'FILTER_HAS_VISION',
      type: 'booleanTag'
    },
    {
      name: 'has_translation',
      label: 'Support traduction',
      labelKey: 'FILTER_HAS_TRANSLATION',
      type: 'booleanTag'
    },
    {
      name: 'is_active',
      label: 'Statut',
      labelKey: 'FILTER_IS_ACTIVE',
      type: 'booleanTag'
    }
  ],
  
  defaultFormData: {
    provider: '',
    model_key: '',
    model_name: '',
    model_identifier: '',
    ia_router: 'default',
    ia_router_url: '',
    has_text: true,
    has_vision: false,
    has_translation: false,
    supported_languages: '',
    is_active: true
  }
};

/**
 * Composant d'administration des modèles IA
 */
export default function AdminIaModelsTab() {
  return (
    <AdminDataTable {...iaModelsConfig} />
  );
}
